import api from "./api";

export async function getSetting(): Promise<any | null> {
    return await api
        .get("api/setting/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
